/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import React, { useEffect } from "react";
import deepEqual from "deep-equal";
import PropTypes from "prop-types";

const EventHandlersManager = React.memo(
    ({ events, enabled }) => {
        const eventNames = Object.keys(events);

        // Fixed Event Handlers
        function genericEventHandler(e) {
            e.stopPropagation();

            events[e.type] instanceof Function
                ? events[e.type](e)
                : events[e.type].callback(e);
        }

        // Mount and unmount handlers
        useEffect(() => {
            if (enabled) {
                eventNames.forEach((eventName) => {
                    if (events[eventName] instanceof Function)
                        window.addEventListener(eventName, genericEventHandler);
                    else {
                        const element = events[eventName].isReactRef
                            ? events[eventName].element.current
                            : events[eventName].element;
                        if (element)
                            element.addEventListener(
                                eventName,
                                genericEventHandler
                            );
                    }
                });
            }

            return () => {
                if (enabled) {
                    eventNames.forEach((eventName) => {
                        if (events[eventName] instanceof Function)
                            window.removeEventListener(
                                eventName,
                                genericEventHandler
                            );
                        else {
                            const element = events[eventName].isReactRef
                                ? events[eventName].element.current
                                : events[eventName].element;
                            try {
                                element.removeEventListener(
                                    eventName,
                                    genericEventHandler
                                );
                            } catch (e) {
                            }
                        }
                    });
                }
            };
        });

        //Render
        return null;
    },
    (s1, s2) =>
        s2.reloadable
            ? deepEqual(s1.events, s2.events)
            : deepEqual(Object.keys(s1.events), Object.keys(s2.events))
);

EventHandlersManager.propTypes = {
    events: PropTypes.any.isRequired,
    enabled: PropTypes.any.isRequired
};

export default EventHandlersManager;
